import React, { useEffect, useState } from 'react';
import Section from '../../../shared/Section/Section';
import { Box, Typography } from '@mui/material';
import { getStats } from '../../../api/strapi';
import Statistic from './Statistic';

export function EventStatisticModule(props) {
  const { title, description, statistic } = props;
  const [info, setInfo] = useState(statistic);
  useEffect(() => {
    const ac = new AbortController();
    const getData = async () => {
      try {
        const statData = await getStats();
        setInfo((prev) =>
          prev.map((item) => {
            const fetchedItem = statData.find((el) => el.id === item.id);
            return {
              ...item,
              value: fetchedItem?.statTitle,
              description: fetchedItem?.statSubTitle,
            };
          }),
        );
      } catch (e) {
        console.error(e);
      }
    };
    getData();
    return () => {
      ac.abort();
    };
  }, []);
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 3,
      }}
    >
      <Box sx={{ width: { xs: '100%', md: 377 } }}>
        <Typography variant="desktopH2" color={'kit.text.main'}>
          {title}
        </Typography>
        <Typography variant="desktopP2" sx={{ fontSize: 16 }} mt={1.5}>
          {description}
        </Typography>
      </Box>
      <Box sx={{ width: { xs: '100%', lg: 800 } }}>
        <Statistic statistic={info} j />
      </Box>
    </Box>
  );
}

export default function EventStatistic(props) {
  return (
    <Section>
      <EventStatisticModule {...props} />
    </Section>
  );
}
